import { useState, useEffect, useCallback } from "react"
import defaultConfig from "config/default"
import { getJSSDKConfig } from "./helper"

const { debug } = defaultConfig

/**
 * @description 微信JS-SDK配置申请（支持失败重新配置）
 * @param jsApiList 检查要申请的权限
 */
export default function useWechatConfig() {
    const [status, setStatus] = useState('preparing')
    const wechatReady = status === 'success'

    const checkReady = useCallback(
        () => {
            window.wx.ready(() => {
                setStatus('success')
            })
            window.wx.error(() => {
                setStatus('fail')
            })
        },
        [],
    )

    const getConfig = useCallback(
        async () => {
            const response = await getJSSDKConfig()
            if (!!response.result) {
                const { result } = response
                window.wx.config({
                    debug,
                    appId: result.appid,
                    signature: result.signature,
                    nonceStr: result.noncestr,
                    timestamp: result.timestamp,
                    jsApiList: [
                        'updateAppMessageShareData',
                        'updateTimelineShareData',
                        'onMenuShareTimeline',
                        'onMenuShareAppMessage',
                        'previewImage'
                    ]
                })
                checkReady()
            } else {
                setStatus('fail')
            }
        },
        [checkReady],
    )

    const handleRetry = useCallback(
        () => {
            if (status === 'fail') {
                setStatus('preparing')
            }
        },
        [status],
    )

    useEffect(
        () => {
            if (status === 'preparing') {
                // 准备状态时，自动配置
                getConfig()
            }
        },
        [status, getConfig],
    )

    return {
        status,
        wechatReady,
        handleRetry,
    }
}